import React from 'react';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
export function SparklineChart(_ref: {
  timeseries: number[];
  comparisonTimeseries: number[];
}) {
  var _timeseries$;
  let {
    timeseries,
    comparisonTimeseries
  }: {
    timeseries: number[];
    comparisonTimeseries: number[];
  } = _ref;
  const yAxisValue = (_timeseries$ = timeseries[0]) !== null && _timeseries$ !== void 0 ? _timeseries$ : 0;
  const data = timeseries.map((y, index) => [index, y]);
  const comparisonData = comparisonTimeseries.map((y, index) => [index, y]);
  const chartOptions = {
    chart: {
      type: "line",
      margin: [2, 0, 2, 0],
      width: 232,
      height: 40,
      style: {
        overflow: "visible"
      },
      animation: false,
      // disable initial animation and all redraw animations
      backgroundColor: null,
      skipKeyboardNavigation: true // Prevent focusability
    },
    title: {
      text: null
    },
    credits: {
      enabled: false // Remove Highcharts branding
    },
    legend: {
      enabled: false // No legend
    },
    xAxis: {
      visible: false // Hide X axis
    },
    yAxis: {
      visible: false // Hide Y asix
    },
    tooltip: {
      enabled: false // Disable tooltips
    },
    series: [{
      data,
      color: "var(--primary-color)",
      threshold: yAxisValue,
      lineWidth: 1.5,
      marker: {
        enabled: false
      },
      dashStyle: "Solid"
    }, {
      data: comparisonData,
      color: "var(--primary-color)",
      threshold: yAxisValue,
      lineWidth: 1.5,
      marker: {
        enabled: false
      },
      dashStyle: "ShortDot"
    }],
    plotOptions: {
      series: {
        animation: false,
        states: {
          hover: {
            enabled: false // Disable hover states
          }
        },
        enableMouseTracking: false // Disable mouse tracking for tooltips
      }
    }
  };
  return <HighchartsReact highcharts={Highcharts} options={chartOptions} data-sentry-element="HighchartsReact" data-sentry-component="SparklineChart" data-sentry-source-file="sparkline-chart.tsx" />;
}